<template>
  <div class="thumbtack-results">
    <div class="thumbtack-results__info">
      <span class="f7">{{ providers.length }} results for '{{ query }}'</span>
      <div class="thumbtack-results__sort">
        <label for="sorting-select" class="f7">Sort by: </label>
        <select name="sorting" id="sorting-select" v-model="sorting" class="f7">
          <option v-for="(option, key, index) in sortOptions" :key="key" :value="key">{{ option.label}}</option>
        </select>
      </div>
    </div>
    <template v-for="(provider, key, index) in results">
      <div v-if="providers.length > 0" :key="provider.business_name">
        <ThumbtackPro :provider="provider" />
      </div>
    </template>
    <div v-if="providers.length > 4 && !resultsExpanded" class="thumbtack-results__show-more text-bold" @click="expandResults">Show More</div>
    <div v-if="providers.length < 1" class="thumbtack-results__empty">
      <span class="f4 text-bold">No results found</span>
      <p>Try another search term or select another category.</p>
    </div>
  </div>
</template>

<script src="./thumbtackresultslist.js"></script>

<style lang="scss">
@use './thumbtackresultslist.scss' as *;
</style>